module.exports = __webpack_public_path__ + "img/footer-logo.3ce95cb4.png";